import { SimpleGrid, GridItem, Text, Button, useDisclosure, ButtonGroup } from '@chakra-ui/react';
import { UploadUserAvatarModal } from "./uploadUserAvatarModal";
import { FC, useEffect } from "react";
import { MeAvatar } from "components";
import { useAppSelector } from "lib/redux";
import { selectMe } from "../accountSlice";
import { useAvatar } from "lib/hooks";
import { baseRESTUrl } from "lib/utils";
import { asyncToDataURL } from 'lib/utils/dataUrls';

export const EditUserAvatar: FC = () => {
  const { isOpen, onClose, onOpen } = useDisclosure();
  const { uploadAvatar, acceptedFileTypes, thumbnailState, setThumbnailState, handleFiles, removeAvatar } = useAvatar();
  const { user } = useAppSelector(selectMe);

  const remove = async() => {
    await removeAvatar();
    onClose();
  }

  useEffect(() => {
    if (user.has_avatar) {
      (async () => {
        const pickImg = await asyncToDataURL(`${baseRESTUrl()}/v1/user/avatar?key=${user.avatarKey}`);
        
        setThumbnailState((thumbnailState) => ({
          ...thumbnailState,
          pickImg
        }));
      })();
    }
  }, [user.avatarKey, user.has_avatar]);

  return (
    <SimpleGrid
      templateColumns={"auto 1fr"}
      gap={6}
      maxWidth={"350px"}
      alignItems={"center"}
    >
      <GridItem>
        <MeAvatar size={"xl"} />
      </GridItem>
      <GridItem>
        <SimpleGrid gap={2}>
          <GridItem>
            <Text size={"sm"} variant={"secondary"}>Add a personal touch to all your packs with a photo, logo or a gif.</Text>
          </GridItem>
          <GridItem>
            <ButtonGroup>
              <Button variant={"primary"} size={"sm"} onClick={() => onOpen()}>
                {user.has_avatar ? "Edit" : "Upload"}
              </Button>
              {user.has_avatar && (
                <Button
                  variant={"light"}
                  size={"sm"}
                  onClick={() => remove()}
                >
                  Remove
                </Button>
              )}
            </ButtonGroup>
            <UploadUserAvatarModal
              isOpen={isOpen}
              onClose={onClose}
              uploadAvatar={uploadAvatar}
              acceptedFileTypes={acceptedFileTypes}
              thumbnailState={thumbnailState}
              handleFiles={handleFiles}
              setThumbnailState={setThumbnailState}
            />
          </GridItem>
        </SimpleGrid>
      </GridItem>
    </SimpleGrid>
  )
}